import React from 'react'
import { useTranslation } from 'react-i18next'

const TableHeaderLanguage = () => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <tr>
      <th>{t('TableHeaderLanguage.language')}</th>
      <th>{t('TableHeaderLanguage.translated')}</th>
    </tr>
  )
}

export default TableHeaderLanguage
